import { n as A } from "./Logger-CmiOOsKC.js";
import { H as U, U as $ } from "./SceneCreation-DVCYLXYF.js";
import { d as x } from "./AssetTypes-DUDo9FdH.js";
import { t as y } from "./Utility-CviQuQTA.js";
import { ImportMeshAsync as v } from "@babylonjs/core/Loading/sceneLoader.js";
import "@babylonjs/loaders/glTF/index.js";
import { GetKHRInteractivityImportResults as E } from "@babylonjs/loaders/glTF/2.0/Extensions/KHR_interactivity.pure.js";
async function w(t, e, n) {
  const i = y.getFileExtensionFromSrc(t) || (n ? "" : L(t, e)), a = n ?? (i ? `.${i}` : ".glb");
  if (x.has(i)) return {
    via: "splat",
    pluginExtension: a
  };
  if (a === ".glb" || a === ".gltf") {
    const r = e.getAsset(t);
    if (r && await j(r)) return {
      via: "direct",
      pluginExtension: a
    };
  }
  return {
    via: "container",
    pluginExtension: a
  };
}
async function S(t, e, n, i = {}) {
  const { via: a, pluginExtension: r } = await w(t, n, i.pluginExtension);
  return a === "splat" ? F(t, e, n, r, i) : a === "direct" ? b(t, e, n, r, i) : P(t, e, n, r, i);
}
async function C(t, e) {
  const { via: n, pluginExtension: i } = await w(t, e);
  return n === "container" ? i : null;
}
function L(t, e) {
  return e.getAsset(t) ? y.getFileExtensionFromSrc(e.resolveUrlToAssetKey(t) ?? t) : "";
}
var h = /* @__PURE__ */ new WeakMap();
function j(t) {
  const e = h.get(t);
  if (e) return e;
  const n = I(t).catch(() => (h.delete(t), !1));
  return h.set(t, n), n;
}
async function I(t) {
  if (t.size < 20) return !1;
  const e = await t.slice(0, 20).arrayBuffer(), n = new DataView(e);
  if (n.getUint32(0, !0) !== 1179937895) return !1;
  const i = n.getUint32(12, !0), a = await t.slice(20, 20 + i).arrayBuffer();
  return new TextDecoder().decode(a).includes('"KHR_interactivity"');
}
async function F(t, e, n, i, a) {
  const r = n.getAsset(t), s = r ? URL.createObjectURL(r) : n.resolveAssetUrl(t) ?? t;
  try {
    const o = (await v(s, e, { pluginExtension: i })).meshes[0];
    if (!o) throw new Error(`No meshes found in ${t}`);
    return i === ".spz" && (o.scaling.y = Math.abs(o.scaling.y)), a.parent && (o.parent = a.parent), {
      root: o,
      instantiatedEntries: null,
      containerPath: ""
    };
  } finally {
    r && URL.revokeObjectURL(s);
  }
}
async function P(t, e, n, i, a) {
  const r = await n.getOrLoadContainer(t, e, i), s = a.namePrefix ? (l) => `${a.namePrefix}_${l}` : (l) => l, o = a.cloneMeshes ?? !1, f = o || !(r.animationGroups.length > 0) ? o : (l) => !!l.morphTargetManager, c = U(r, s, r.animationGroups.some((l) => $(l) !== void 0), { doNotInstantiate: f });
  if (c.rootNodes.length === 0)
    throw n.releaseContainer(t), new Error(`No meshes found in ${t}`);
  const u = c.rootNodes[0];
  return {
    root: R(u, i, a),
    instantiatedEntries: c,
    containerPath: t
  };
}
async function b(t, e, n, i, a) {
  const r = n.getAsset(t), s = r ? URL.createObjectURL(r) : t, o = r ? n.createGltfExternalRefResolver(t, s) : void 0;
  let f, c, u;
  try {
    const l = await v(s, e, {
      pluginExtension: i,
      pluginOptions: { gltf: {
        ...o ? { preprocessUrlAsync: o.preprocessUrlAsync } : {},
        onParsed: (g) => {
          const d = g.json;
          u = d, f = d?.extensionsUsed, c = d?.extensions?.KHR_interactivity;
        }
      } }
    }), m = l.transformNodes.find((g) => g.name === "__root__") ?? l.meshes[0];
    if (!m) throw new Error(`No meshes found in ${t}`);
    const _ = R(m, i, a), p = G(e, u, t);
    return {
      root: _,
      instantiatedEntries: null,
      containerPath: "",
      extensionsUsed: f,
      khrInteractivity: c,
      ...p.length > 0 ? { khrDiagnostics: p } : {}
    };
  } finally {
    r && URL.revokeObjectURL(s), o?.dispose();
  }
}
function G(t, e, n) {
  if (!e) return [];
  const i = E(t).find((s) => s.glTF === e);
  if (!i) return [];
  const a = i.document.diagnostics.map((s) => `${s.path}: ${s.message}`), r = [];
  for (const s of i.graphs)
    if (s.diagnostics.length !== 0) {
      r.push(s.graph.index);
      for (const o of s.diagnostics) a.push(`${o.path}: ${o.message}`);
    }
  if (a.length > 0) {
    const s = r.length > 0 ? ` (graph ${r.map((o) => `#${o}`).join(", ")})` : "";
    A.warn(`[ModelLoader] KHR_interactivity in ${n}: ${a.length} diagnostic(s)${s} — non-conformant graphs are skipped. First: ${a[0]}`);
  }
  return a;
}
function R(t, e, n) {
  const i = t.getChildren(), a = e === ".glb" || e === ".gltf", r = n.resetTransform ?? !1;
  if (i.length === 1 && a) {
    const s = i[0];
    return r && (s.position.setAll(0), s.rotationQuaternion = null, s.rotation.setAll(0), s.scaling.setAll(1)), s.parent = n.parent ?? null, t.dispose(), s;
  }
  return n.parent && (t.parent = n.parent), r && (t.position.setAll(0), t.rotationQuaternion = null, t.rotation.setAll(0), t.scaling.setAll(1)), t;
}
export {
  C as n,
  S as t
};

//# sourceMappingURL=ModelLoader-CCmBcIkj.js.map